<template>
    <div class="">
        <video ref="videoRef" :src="videoSrc" width="100%" height="auto" controls></video>
    </div>
</template>

<script>
import { defineComponent, onActivated, ref } from 'vue';
import { useRoute } from 'vue-router';

export default defineComponent({
    setup() {
        const route = useRoute();

        const videoSrc = ref('');

        const videoRef = ref();

        const rangeVideo = () => {
            const totalSize = 5524488;
            const chunkSize = 1000000;
            const numChunks = Math.ceil(totalSize / chunkSize);
            let index = 0;

            const assetURL = "http://file.visionhealthmed.com/file/frag_bunny.mp4";
            var mimeCodec = 'video/mp4; codecs="avc1.42E01E, mp4a.40.2"';

            if ("MediaSource" in window && MediaSource.isTypeSupported(mimeCodec)) {
                var mediaSource = new MediaSource();
                videoRef.value.src = URL.createObjectURL(mediaSource);
                mediaSource.addEventListener("sourceopen", sourceOpen);
            } else {
                console.error("Unsupported MIME type or codec: ", mimeCodec);
            }

            function sourceOpen(e) {
                var mediaSource = e.target;
                var sourceBuffer = mediaSource.addSourceBuffer(mimeCodec);

                const send = () => {
                    if (index >= numChunks) {
                        sourceBuffer.addEventListener("updateend", function (_) {
                            mediaSource.endOfStream();
                        });
                    } else {
                        const start = index * chunkSize;
                        const end = Math.min(start + chunkSize - 1, totalSize - 1);

                        function fetchAB(url, cb) {
                            const xhr = new XMLHttpRequest();
                            xhr.open("get", url);
                            xhr.setRequestHeader('Range', `bytes=${start}-${end}`)
                            xhr.responseType = "arraybuffer";
                            xhr.onload = function () {
                                cb(xhr.response);
                            };
                            xhr.send();
                        }

                        fetchAB(assetURL, (response) => {
                            index++;
                            sourceBuffer.appendBuffer(response);
                            send();
                            videoRef.value.play();
                        })
                    }
                };

                send();
            }
        };

        const video = () => {
            
        }

        onActivated(() => {
            videoSrc.value = route.query.videourl;
            // rangeVideo();

            // videoRef.value.onseeked = (event) => {
            //     console.log(event);
            // };
        });


        return {
            videoSrc,
            videoRef,
        };
    }
});
</script>

<style lang="less" scoped></style>
